<template>
    <b-spinner v-if="!apps"/>
    <div v-else>
        <b-alert show variant="warning" class="mb-4">
            <b-icon icon="exclamation-triangle-fill"></b-icon>
            <strong>{{ $t('platformDeprecated') }}</strong> {{ $t('platformDeprecatedMessage') }} 
            <strong>{{ $t('forge') }}</strong> {{ $t('asModernReplacement') }}
        </b-alert>
        <b-row>
            <b-col cols="12" class="mb-4">
                
                <b-row>
                    <b-col cols="3" md="1"><b-button block variant="warning" @click="goToPlayground">Playground</b-button></b-col>
                </b-row>
            </b-col>
            <b-col cols="12" md="3" v-for="app in apps" :key="app.uuid">
                <b-card class="publicapp" @click="$router.push(`/admin/public-app/${app.uuid}`)">
                    <b-card-header>{{ app.name }}</b-card-header> 
                    

                    <div class="mt-3">
                        <b-badge class="mr-1" v-if="app.basehostname">{{ stageHostname(app) }}</b-badge>
                        <b-badge class="mr-1">{{ app.basehostname }}</b-badge>
                        <b-badge v-for="host in app.hostnames" :key="host" class="mr-1"> {{ host }} </b-badge>
                    </div>

                    <br />
                    <b-icon icon="wrench"></b-icon> <small> {{ app.dev_version || "not active" }}</small>
                    <br />
                    <b-icon icon="people"></b-icon>  <small> {{ app.public_version || "not live" }}</small>
                </b-card>
            </b-col>
        </b-row>

        <span v-if="apps.length < 1">{{ $t('noApps') }}. </span>
    </div>
    
</template>
<script>
export default {
    name: 'List',
    components: { },
    data: function() {
        return {
            apps: null,
            fields: ["name"]
        }
    },
    methods: {
        goToApp(item) {
            this.$router.push("/admin/public-app/" + item.uuid)
        },

        stageHostname(app) {
            let parts = app.basehostname.split(".")

            parts.splice(1, 0, 'stage')

            return parts.join(".")
        },

        goToPlayground() {
            window.open(this.$env.get('PUBLIC_APP_PLAYGROUND'), "_blank")
        }
    },
    mounted() {
       if (!this.$can("manage base_public_apps")) {
            return this.$router.back();
       }

       this.$http.get("/v3/system/gateway/app-service/public-app/all").then(resp => {
            this.apps = resp.data || []
       }).catch(err => {
           this.$debugLog(err)
           this.$mainDialog.msgBoxOk("Failed to fetch apps.")
       })
    }
}
</script>

<style scoped>
.publicapp {
    cursor: pointer;
}
</style>
